// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function Divider(props) {
  return JsxRuntime.jsx("div", {
              className: "border-t border-zinc-200"
            });
}

var make = Divider;

exports.make = make;
/* react/jsx-runtime Not a pure module */
